import { useEffect, useState } from 'react';

import { PlanTypes } from '../enrollmentModal.types';

import {
  EnrollmentFormField,
  EnrollmentFormFields,
  EnrollmentFormValidationParams,
  useEnrollmentForm,
} from './useEnrollmentForm';

interface UseDynamicEnrollmentFormParams {
  defaultFormValues: Partial<EnrollmentFormFields>;
  validationParams?: EnrollmentFormValidationParams;
}

export const useDynamicEnrollmentForm = ({
  defaultFormValues,
  validationParams,
}: UseDynamicEnrollmentFormParams) => {
  const [formType, setFormType] = useState(defaultFormValues.type);
  const onlyHealthPlanFields = formType === PlanTypes.HEALTH;
  const { methods } = useEnrollmentForm(defaultFormValues, validationParams, onlyHealthPlanFields);
  const watchedType = methods.watch(EnrollmentFormField.type);
  const defaultType = defaultFormValues.type;

  // Re-apply the plan type default once plan/health-plan options resolve after mount
  // (RHF reads defaultValues only once); skip if the user changed it manually.
  useEffect(() => {
    if (
      defaultType &&
      defaultType !== watchedType &&
      !methods.getFieldState(EnrollmentFormField.type).isDirty
    ) {
      methods.setValue(EnrollmentFormField.type, defaultType);
    }
  }, [defaultType, watchedType, methods]);

  useEffect(() => {
    if (watchedType !== formType) {
      setFormType(watchedType);
    }
  }, [watchedType, formType]);

  return { methods, formType };
};
